import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { Px2RemService } from 'src/app/services/px2-rem.service';

interface VehicleData {
  brand: string;
  model: string;
  type: string;
}

@Component({
  selector: 'vehicle-modal',
  templateUrl: './vehicle-modal.component.html',
  styleUrls: ['./vehicle-modal.component.less']
})
export class VehicleModalComponent implements OnInit {

  @Input() isVehicleVisible: boolean = false; 
  @Input() articleId: number | undefined; 
  @Input() vehicles: any[] = []; 
  @Input() brand: any = ''; 
  @Input() model: any = ''; 
  @Output() handleClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  searchFormData!: FormGroup;
  vehicleData: any[] = [];
  modelList: any[] = [];
  constructor(private fb: FormBuilder,private px2RemService:Px2RemService,private ecatalogService:EcatalogService) { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    // check isVehicleVisible 
    if (changes['isVehicleVisible'] && changes['isVehicleVisible'].currentValue === true) {
      this.searchFormData = this.fb.group({
        brand: [this.brand, []],
        model: [this.model, []]
      });
      this.getVehicleModel();
    }
  }

  closeModal() {
    this.handleClose.emit(false);
  }

  getFormattedLabel(model: any): string {
    if (model && model.yearOfConstructionFrom) {
      return  model.yearOfConstructionFrom.toString().substring(4) + '.' + model.yearOfConstructionFrom.toString().substring(0, 4) + (model.yearOfConstructionTo?('-' + model.yearOfConstructionTo.toString().substring(4) + '.' + model.yearOfConstructionTo.toString().substring(0, 4)):'');
    }
    return '';
  }

  getFormattedModelLabel(model: any): string {
    if (model && model.name) {
      return `${model.manufacturer} - ${model.name} `
    }
    return '';
  }

  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }

  handleChange(e: Event):void{
    this.searchFormData.get('model')?.setValue("");
    this.getVehicleModel();
    this.ecatalogService.queryVehicleModelSeries({
      "manuId": this.searchFormData.value.brand,
    }).subscribe(res => {
      this.modelList = res.rtnData || [];
    });
  }

  handleChangeModel(): void {
    this.getVehicleModel();
  }

  getVehicleModel():void{
    let params={
      "articleId": this.articleId,
      "linkingTargetManuId": this.searchFormData.value.brand,
      "linkingTargetModelClass": this.searchFormData.get('model')?.value?.name,
      "linkingTargetManufacturer": this.searchFormData.get('model')?.value?.manufacturer,
      "linkingTargetModelId": this.searchFormData.get('model')?.value?.id,
      "linkingTargetType": ""
    }
     this.ecatalogService.getVehicleModel(params).subscribe((result: any) => {
      this.vehicleData=result.rtnData;
    });
  }

}
